module.exports = __webpack_public_path__ + "img/checkmark.e8d10fef.svg";